<!--
# -----------------------------------------------------------------------------
# Component: PolicyRenewalInfo.vue
# Author: PST
# Created Date: 27/Oct/2020
# Comments: Policy Header -> Risk Renewal Information Tab
# -----------------------------------------------------------------------------
-->
<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-format-align-justify</v-icon>
              <v-toolbar-title class="toolbar-title-2">{{labels.mainTitle}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap align-center>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-checkbox color="primary" v-model="mainForm.confmRen" :label="labels.confmRen" :disabled="polMaster.endtCnt > 0"></v-checkbox>
                  </v-flex>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-subheader class="queryGreenLabel">{{mainForm.renewalInfoText}}</v-subheader>
                  </v-flex>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                    <div class="queryValue">{{mainForm.createdDate}}</div>
                  </v-flex>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
                    <div class="queryValue">{{mainForm.createdBy}}</div>
                  </v-flex>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
                    <div class="queryValue">{{mainForm.modifiedDate}}</div>
                  </v-flex>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
                    <div class="queryValue">{{mainForm.modifiedBy}}</div>
                  </v-flex>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-subheader class="queryLabel">{{labels.prtNotDate}}</v-subheader>
                    <div class="queryValue">{{mainForm.prtNotDate}}</div>
                  </v-flex>
                  <v-flex sm6 md6 lg6 xs12>
                    <v-subheader class="queryLabel">{{labels.prtNotBy}}</v-subheader>
                    <div class="queryValue">{{mainForm.prtNotBy}}</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider class="mt-2"></v-divider>
                  </v-flex>
                  <v-flex xs12 v-if="this.polMaster.endtCnt === 0">
                    <v-btn color="error" dark :loading="loading" @click.prevent="doCancel">
                      {{labels.cancel}}
                      <v-icon dark right>mdi-cancel</v-icon>
                    </v-btn>
                    <v-btn color="info" dark :loading="loading" @click.prevent="doSave">
                      {{labels.save}}
                      <v-icon dark right>mdi-content-save</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-dialog v-model="loading" persistent width="300">
                  <v-card color="primary" dark>
                    <v-card-text>
                      Processing...
                      <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="showErrorDialog" width="800px" >
                  <v-card>
                    <v-toolbar dense color="grey lighten-3" flat>
                      <v-icon>mdi-information</v-icon>
                      <v-toolbar-title>System Information</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <div v-if="messages.length > 0" class="pb-3">
                      <span class="info-dialog-msg-header">Oops something went wrong...</span>
                      <v-spacer class="mt-2"></v-spacer>
                      <ul class="showErrorMsgs">
                        <li v-for="(error, index) in messages" :key="index">
                        {{error.message}}
                        </li>
                      </ul>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDateTime4 } from '@/utils/date'
import clone from 'clone'

export default {
  data () {
    return {
      labels: {
        mainTitle: 'Policy Renewal Information',
        confmRen: 'Confirm Renewal',
        prtNotBy: 'Renewal Notice Printed By',
        prtNotDate: 'Renewal Notice Printed Date',
        createdBy: 'Renewed By',
        createdDate: 'Renewed Date',
        modifiedBy: 'Last Reviewed By',
        modifiedDate: 'Last Reviewed Date',
        cancel: 'Cancel',
        save: 'Save',
        proceed: 'Proceed'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        confmRen: undefined,
        renewalInfoText: undefined,
        prtNotBy: undefined,
        prtNotDate: undefined,
        renProgId: undefined,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined
      },
      resetForm: {
        polNo: undefined,
        renCnt: undefined,
        confmRen: undefined,
        renewalInfoText: undefined,
        prtNotBy: undefined,
        prtNotDate: undefined,
        renProgId: undefined,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined
      },
      loading: false,
      showErrorDialog: false
    }
  },
  watch: {
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  methods: {
    doInit() {
      this.fetchData()
    },
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.policyRenewalInfo
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result.data
            this.mainForm.polNo = this.polMaster.polNo
            this.mainForm.renCnt = this.polMaster.renCnt
            this.mainForm.confmRen = data.confmRen !== null ? data.confmRen : false
            if (data.renProgId === 'RenEnt') {
              this.mainForm.renewalInfoText = 'Enter Renewal'
            } else if (data.renProgId === 'BchRen') {
              this.mainForm.renewalInfoText = 'Generate Renewal'
            } else if (data.renProgId === 'UWO500') {
              this.mainForm.renewalInfoText = 'Enter Renewal'
            } else {
              this.mainForm.renewalInfoText = ''
            }
            this.mainForm.prtNotBy = data.prtNotBy
            this.mainForm.prtNotDate = formatDisplayDateTime4(data.prtNotDate)
            this.mainForm.renProgId = data.renProgId
            this.mainForm.createdBy = data.createdBy
            this.mainForm.createdDate = formatDisplayDateTime4(data.createdDate)
            this.mainForm.modifiedBy = this.polMaster.endtCnt > 0 ? data.modifiedBy : data.currentUser
            this.mainForm.modifiedDate = this.polMaster.endtCnt > 0 ? formatDisplayDateTime4(data.modifiedDate) : formatDisplayDateTime4(new Date())

            this.resetForm = clone(this.mainForm)
          }

          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [policyRenewalInfo]')
      }
    },
    doCancel() {
      this.mainForm = clone(this.resetForm)
      this.$toast.success('Policy Renewal Information successfully reset.')
    },
    doSave() {
      const apiURI = this.$store.state.underwriting.policyHeaderSettings.menu.savePolicyRenewalInfo
      if (apiURI) {
        this.loading = true
        this.$http.post(apiURI, this.mainForm).then(result => {
          const { data } = result
          if (data) {
            this.doInit()
            this.$toast.success('Policy Renewal Information successfully saved.')
          }
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  beforeMount() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>
